import React, { useCallback, useEffect, useMemo, useState } from "react";
import { EuiFlexGroup, EuiFlexItem } from "@elastic/eui";
import { PieChartPanel } from "../../../../components/Charts/PieChart";
import { toDecimalString } from "../../../../../../shared/utils/numbers";
import { COLORS, PIECHARTS } from "../constants";


export const PieChartPanelScreen = (props:any) =>{

    const {data,style} = props;

    const getData = useMemo(() =>{
      return PIECHARTS(data)
    },[data])

    const renderDataTooltip = (payload:any) =>{
        return payload.map((p:any,i:number)=>{
            return <p style={{color:payload[i].payload.fill, fill:payload[i].payload.fill}}>{`${payload[i].name}: ${toDecimalString(payload[i].value)}`}</p>
        })
    }

    const customTooltip = (dataToolTip:any) => {
        const { active, payload, label } = dataToolTip;
        
        if (active && payload && payload.length) {
          return (
            <div className="custom-tooltip">
              {renderDataTooltip(payload)}
            </div>
          );
        }
      
        return null;
    };

    return (
        <EuiFlexGroup style={{...{height:'95%'}, ...style}}>
            <EuiFlexItem>
            <PieChartPanel data={getData} showTotal customToolTip={customTooltip} colors={COLORS}/>
            </EuiFlexItem>
        </EuiFlexGroup>
    )
}